import { removeNonNumbers } from '@ott/transforms';
import { maxCVVLength } from '../../../constants';

export const transformCVV = (cvv: string) => removeNonNumbers(cvv).slice(0, maxCVVLength);
